import * as types from './formStructureActionTypes';

export const getFormBySeason = (seasonId, countrySfId) => ({
  type: types.GET_FORM_REQUEST,
  seasonId,
  countrySfId,
});



// WEBPACK FOOTER //
// ./src/store/formStructure/formStructureActions.js